module.exports = __webpack_public_path__ + "static/media/sweetkilling.c0ea0944.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/sweetkilling.mp3
 ** module id = 674
 ** module chunks = 0
 **/